module.exports = __webpack_public_path__ + "4102de29eb801d6572a6b43af3fa10fe.svg";